<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="text-center">
        <div class="container">
          <div class="row text-center">
            <div class="col-md-8 col-md-offset-2 text-center ml-auto mr-auto">
              <h2 class="title text-danger">404 Página não encontrada !</h2>
              <h2 class="title">Caso o link esteja correto, entre em contato.</h2>
              <router-link class="btn btn-fill" :to="{path:'/'}">Página Principal</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {}

</script>
